var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFerry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 533,
    viewBox: "0 0 533 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.499 1.15269e-05C119.55 1.15269e-05 0 119.553 0 266.504C0 413.447 119.55 533 266.499 533C413.447 533 533 413.447 533 266.504C533 119.553 413.447 1.15269e-05 266.499 1.15269e-05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.499 488C144.362 488 45 388.633 45 266.503C45 144.368 144.362 45 266.499 45C388.632 45 488 144.368 488 266.503C488 388.633 388.632 488 266.499 488",
    fill: "#52BE36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.294 410C202.646 410 200 408.487 200 404.722V134H349.328C352.357 134 355 135.877 355 139.279V175.849C355 178.493 353.86 181.88 349.71 181.88H254.436V254.278H341.767C344.792 254.278 346.681 256.545 346.681 259.939V295.376C346.681 298.394 344.792 300.66 341.767 300.66H254.436V404.722C254.436 408.113 251.786 410 249.521 410H205.294Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerry);
export default __webpack_public_path__ + "static/media/Ferry.fa037de9.svg";
export { ForwardRef as ReactComponent };